import { Button, Col, Input, Row, Text, message, Divider } from 'components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { OBJECT_ID_REGEX } from 'utils/constants';
import {
  findById as findRetsOpenHouseById,
  findLatestRetsOpenHouseByRetsUniqueId,
} from '../../../../../api/RetsOpenHouseController';
import TriggerRetsUpdatePageContext from './TriggerRetsOpenHouseUpdatePageContext';

const OpenHouseFinder: React.FC = () => {
  const {
    listingRef,
    setListingRef,
    retsOpenHouseId,
    setRetsOpenHouseId,
    retsUniqueId,
    setRetsUniqueId,
    setRetsOpenHouse,
    setUpdates,
  } = useContext(TriggerRetsUpdatePageContext);

  const getOpenHouse = async () => {
    const validId = Boolean(retsOpenHouseId.match(OBJECT_ID_REGEX));
    const validNumber = Boolean(retsUniqueId);
    if (!validId && !validNumber)
      return message.error(
        'Not enough info entered to find retsopenhouse entry',
      );

    try {
      const res = validId
        ? await findRetsOpenHouseById(retsOpenHouseId)
        : await findLatestRetsOpenHouseByRetsUniqueId({
            retsUniqueId,
            listingRef,
          });
      setRetsOpenHouse(res);
      // @ts-ignore
      setRetsOpenHouseId(res._id.toString());
      setRetsUniqueId(res.retsUniqueId);
      setListingRef(res.listingRef);
      setUpdates({});
    } catch (e) {
      message.error(e?.response?.data?.message || 'Could not find Open House');
    }
  };

  return (
    <StyledForm>
      <Text>Select Open House (Choose one of the two selection methods)</Text>
      <Row gutter={32}>
        <Col span={12}>
          <Input
            label="Open House retsUniqueId"
            required
            value={retsUniqueId}
            onChange={e => {
              setRetsUniqueId(e.target.value);
              setRetsOpenHouseId('');
            }}
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Input
            label="Open House listingRef"
            value={listingRef}
            onChange={e => {
              setListingRef(e.target.value);
              setRetsOpenHouseId('');
            }}
          />
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={12}>
          <Input
            label="Open House ObjectId"
            maxLength={24}
            showCount
            required
            value={retsOpenHouseId}
            onChange={e => setRetsOpenHouseId(e.currentTarget.value)}
          />
        </Col>
      </Row>

      <StyledButton onClick={getOpenHouse}>Find Open House</StyledButton>
    </StyledForm>
  );
};

export default OpenHouseFinder;

const StyledForm = styled.form`
  width: 850px;
  display: grid;
  grid-gap: 15px;
`;

const StyledButton = styled(Button)`
  margin-top: 30px;
`;

/*
START HERE
- finish finder
- move on to Editer (refactor to use some parts of LISTING editor)
- write tests for all new BE f11y

*/
